import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services';

export type MedicineItem = {
  order_type_id: string;
  medication_name?: string;
  dosage?: string;
  frequency?: string;
  duration?: string;
  confidence?: number;
  evidence?: string;
  icd10_code?: string;
  snomed_code?: string;
  snomed_code_description?: string;
  safety_alerts?: string;
  historical_pattern?: string;
  [key: string]: any; // Allow additional properties
};

export type UpdateMedicineSummaryParams = {
  encounterId: string;
  medicines: MedicineItem[];
};

type UpdateMedicineSummaryResponse = {
  message: string;
};

export const useUpdateMedicineSummary = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      encounterId,
      medicines,
    }: UpdateMedicineSummaryParams) => {
      const response = await ambientApi.put<UpdateMedicineSummaryResponse>(
        `/encounter/${encounterId}/medicines`,
        { medicines }
      );
      return response.data;
    },
    onSuccess: (_, variables) => {
      // Invalidate and refetch medicine summaries for this encounter
      queryClient.invalidateQueries({
        queryKey: ['summaries', variables.encounterId, 'in-visit', 'medicine'],
      });

      // Also invalidate the general summaries query
      queryClient.invalidateQueries({
        queryKey: ['summaries', variables.encounterId],
      });
    },
  });
};
